import { isMalformedAmount } from './moneyPayload';

/**
 * THE refusal for a gag / task "Estimated days" / "Actual days" box that holds text the browser
 * could not read (input audit #6, 2026-10-29). Those boxes are `ui/NumberInput`, which emits
 * `MALFORMED_NUMBER` for unreadable text instead of `''` — and `''` is what the server reads as
 * "no estimate" (`helpers/estimateDays.js`), so before this a typo silently CLEARED a stored one.
 * Shown inline under the box AND refused at Save, on every surface (gag panel, the Breakdown's
 * shared row draft, task editor, task create). → `null` when the value may be sent.
 * 🔑 ONLY unreadable text is caught here: blank still clears, and a readable value (`0`, `0.3`,
 * `0.1`) still goes to the server as typed — its quarter-day rounding and its named refusal of
 * anything below 0.25 are unchanged.
 */
export function unreadableDaysProblem(label, value) {
  return isMalformedAmount(value) ? `${label} is not a number — type days like 1.5` : null;
}

/** The inline problem line's classes (red pair, measured house shade). */
export const DAYS_PROBLEM_CLASS = 'mt-1 text-xs text-red-600 dark:text-red-400';
